import script from "./CaskVideoCardPro.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskVideoCardPro.vue?vue&type=script&setup=true&lang=js"

import "./CaskVideoCardPro.vue?vue&type=style&index=0&id=1ffc6e8b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffc6e8b"]])

export default __exports__